<template>
  <div
    data-component="base-icon"
    class="flex items-center justify-center"
  >
    <svg
      v-if="useSvg"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      :class="sizeClasses"
    >
      <use :href="`#${icon}`" />
    </svg>
    <or-icon
      v-else
      :icon="icon"
      :variant="variant"
      :size="size"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue-demi';
import { OrIconV3 as OrIcon, IconVariant, IconSize } from '@onereach/ui-components-25';

export default defineComponent({
  name: 'BaseIcon',
  components: { OrIcon },
  props: {
    useSvg: Boolean,
    icon: {
      type: String,
      required: true,
    },
    /* NOTE: works only for material icons */
    variant: {
      type: String as PropType<IconVariant>,
      default: IconVariant.Outlined,
    },
    size: {
      type: String as PropType<IconSize>,
      default: IconSize.M,
    },
  },
  setup(props) {
    const sizeClasses = computed(() => {
      switch (props.size) {
        case IconSize.L:
          return 'w-lg md:w-md+ h-lg md:h-md+';
        case IconSize.XL:
          return 'w-lg+ md:w-lg h-lg+ md:h-lg';
        case IconSize.Inherit:
          return 'w-full h-full';
        default:
          return 'w-md+ md:w-md h-md+ md:h-md';
      }
    });
    return {
      sizeClasses,
    };
  },
});
</script>
